// ─────────────────────────────────────────────────────────────────────────────
// isPdfUrl — single source of truth for "is this URL a PDF?" across the
// frontend. Used by Tasks list view, EditTask dialog, and any future
// attachment-rendering site.
//
// The backend stores drawing attachments under /uploads/task_images/ with
// their original extension (.pdf, .png, .jpg, ...). The frontend needs to
// branch on extension to avoid rendering a PDF inside an <img>, which
// produces the browser "broken image" glyph.
//
// Matches:
//   - ".pdf" at the end of the string
//   - ".PDF" (case-insensitive)
//   - ".pdf?<signed-url-qs>"  e.g. signed S3 URLs
//   - ".pdf#page=2"           e.g. PDF fragment identifiers
//
// Does NOT match things that merely CONTAIN ".pdf" somewhere in the middle
// (e.g. "/uploads/task_images/foo.pdf.png" is an image, not a PDF).
//
// Display-only. Do NOT use to decide whether a file should be accepted as an
// upload — use MIME-type checking for that (see AddTask.jsx).
// ─────────────────────────────────────────────────────────────────────────────

/**
 * @param {string|null|undefined} url
 * @returns {boolean}
 */
export const isPdfUrl = (url) => /\.pdf(\?|#|$)/i.test(String(url || ""));

export default isPdfUrl;
